import React from "react";
import { Checkbox as MaterialCheckbox } from "@material-ui/core";
import PropTypes from "prop-types";
import FormHelperText from "@material-ui/core/FormHelperText";

/**
 *Komponente, um true und false als Eingabe abzubilden
 *
 * @param id
 * @param children Die anzuzeigende Beschriftung
 * @param error
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EACheckbox({ id, children, error, ...rest }) {
    return (
        <div id={id + "Wrapper"} style={rest.style} className={rest.className}>
            <MaterialCheckbox id={id} color="primary" {...rest} />
            {children && (
                <label
                    htmlFor={rest.disabled ? "idDieHoffentlichNieVerwendungFindet" : rest.forId ? rest.forId : id}
                    style={error ? { color: "#f44336" } : {}}
                >
                    {children}
                </label>
            )}
            {error && (
                <FormHelperText id={id + "-helper-text"} error>
                    {error}
                </FormHelperText>
            )}
        </div>
    );
}

EACheckbox.propTypes = {
    id: PropTypes.string.isRequired,
    error: PropTypes.string,
    children: PropTypes.any,
};

export default EACheckbox;
